import React, {CSSProperties, ReactElement} from "react";
import classes from './ProgressBar.module.scss'

interface Props {
	style?: CSSProperties,
	className?: string,
	maxLength: number,
	fill: number
}

const createArray = (length: number) => new Array(length).fill(null).map((item, index) => index)

const ProgressBar = (props: Props): ReactElement<Props> => {
	return (
		<div
			className={props.className}
			style={{
			...props.style
		}}>
			<div className={classes.container}>
				{createArray(props.maxLength).map((value) => {
					if(value < props.fill)
						return <div key={value} className={classes.filled}/>
					return <div key={value} className={classes.empty}/>
				})}
			</div>
		</div>
	)
}

export default ProgressBar